<template>
  <div class="login-container">
    <div class="login-bg-decor"></div>
    <div class="login-box">
      <h2 class="login-title">个人资料管理工具</h2>
      <!--<p class="login-subtitle">个人用途的信息管理工具 · 不对外开放注册与访问</p>-->
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" label-position="top">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="loginForm.username" placeholder="请输入用户名" prefix-icon="el-icon-user"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="loginForm.password" placeholder="请输入密码" prefix-icon="el-icon-lock" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleLogin" :loading="loading" style="width: 100%">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="beian-footer">
      备案号:
      <a
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
        rel="noopener noreferrer"
      >
        豫ICP备2026011316号-1
      </a>
    </div>
  </div>
</template>

<script>
import request from '../utils/request'
import { setToken, setUserInfo } from '../utils/auth'

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6个字符', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true
          request.post('/auth/login', this.loginForm)
            .then(response => {
              if (response.success) {
                setToken(response.token)
                const u = {
                  ...(response.user || {}),
                  dataScopeAll: !!response.dataScopeAll,
                  allowedDeptIds: Array.isArray(response.allowedDeptIds) ? response.allowedDeptIds : []
                }
                setUserInfo(u)
                
                // 跳转到首页
                this.$router.push('/')
                this.$message.success('登录成功')
              } else {
                this.$message.error('用户名或密码错误')
              }
            })
            .catch(error => {
              console.error('登录失败:', error)
              this.$message.error('登录失败，请稍后重试')
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: radial-gradient(circle at top left, #e6f8f0 0, #f5fbff 40%, #eef5ff 80%);
  padding: 0 20px;
  position: relative;
  overflow: hidden;
}

.login-bg-decor {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 0% 0%, rgba(23, 182, 118, 0.18), transparent 60%),
    radial-gradient(circle at 100% 100%, rgba(15, 155, 215, 0.18), transparent 55%),
    linear-gradient(135deg, rgba(255, 255, 255, 0.85), rgba(255, 255, 255, 0.9));
  z-index: 0;
}

.login-box {
  width: 100%;
  max-width: 400px;
  background-color: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.16);
  position: relative;
  z-index: 1;
}

.beian-footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 16px;
  z-index: 1;
  text-align: center;
  font-size: 12px;
  color: #666;
}

.beian-footer a {
  color: #0f8f59;
  text-decoration: none;
}

.beian-footer a:hover {
  text-decoration: underline;
}

.login-title {
  text-align: center;
  margin-bottom: 30px;
  color: #0f8f59;
  font-size: 24px;
  font-weight: 600;
}

.login-subtitle {
  text-align: center;
  margin-top: -20px;
  margin-bottom: 24px;
  font-size: 13px;
  color: #666;
  letter-spacing: 2px;
}

@media (max-width: 768px) {
  .login-box {
    padding: 28px 22px;
  }

  .beian-footer {
    bottom: 10px;
    font-size: 11px;
  }
}
</style>